import { useQuery } from "@tanstack/react-query";
import { mapLocaleToDatePickerLocale } from "app-settings/localesAndCurrencies";
import { Locale } from "app-settings/localesAndCurrencies";
import { formatDuration, intervalToDuration } from "date-fns";

export function useIntlDurationFormat({
  locale,
  delayMins,
}: {
  locale: Locale;
  delayMins: number;
}) {
  const { data: datePickerLocale } = useQuery({
    queryKey: ["localeDate", { locale }],
    queryFn: () => mapLocaleToDatePickerLocale(locale),
  });

  const duration = intervalToDuration({ start: 0, end: delayMins * 60 * 1000 });
  return formatDuration(duration, { format: ["hours", "minutes"], locale: datePickerLocale });
}
